var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "download"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_46_3306",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.666504,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_46_3306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "download_2",
    d: "M8.66634 10.6665L5.33301 7.33317L6.26634 6.3665L7.99967 8.09984V2.6665H9.33301V8.09984L11.0663 6.3665L11.9997 7.33317L8.66634 10.6665ZM4.66634 13.3332C4.29967 13.3332 3.98579 13.2026 3.72467 12.9415C3.46356 12.6804 3.33301 12.3665 3.33301 11.9998V9.99984H4.66634V11.9998H12.6663V9.99984H13.9997V11.9998C13.9997 12.3665 13.8691 12.6804 13.608 12.9415C13.3469 13.2026 13.033 13.3332 12.6663 13.3332H4.66634Z",
    fill: "#7C8D7E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.cdddfe05be137529a8b8acb6c29e367e.svg";
export { ForwardRef as ReactComponent };